/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import useRouter from 'js/lib/useRouter';

import { Button, Grid, Link, Typography2 } from '@coursera/cds-core';
import { ReadingIcon } from '@coursera/cds-icons';

import { getHomeUrl } from 'bundles/common/utils/courseUrl';
import { TrackedA } from 'bundles/page/components/TrackedLink2';

import _t from 'i18n!nls/degree-home';

import { useCoursesContext } from './v2/CoursesProvider';

type Props = {
  statusText: string;
  isCourseEnrollable: boolean;
  courseName: string;
  courseSlug: string;
  courseId: string;
};

const styles = {
  status: () => css`
    padding: var(--cds-spacing-50) 0;
  `,
  enrollBtn: () => css`
    margin: calc(var(--cds-spacing-100) * -1) 0;
  `,
  icon: css`
    display: block; /* Removes space under the icon for correct alignment */
  `,
};

export const SummaryCourseItem = ({ statusText, isCourseEnrollable, courseName, courseSlug, courseId }: Props) => {
  const { setShowEnrollmentDialog } = useCoursesContext();
  const router = useRouter();

  const handleEnrollClick = () => {
    router.push({
      ...router.location,
      params: router.params,
      query: {
        ...router.location.query,
        enrollingCourseId: courseId,
        showEnrollmentDialog: true,
      },
    });

    setShowEnrollmentDialog(true);
  };

  const courseLink = getHomeUrl(`/learn/${courseSlug}`);

  return (
    <Grid container spacing={24} alignItems="center">
      <Grid item>
        <ReadingIcon css={styles.icon} size="large" />
      </Grid>
      <Grid item xs>
        {!isCourseEnrollable ? (
          <Link component={TrackedA} href={courseLink} trackingName="nav_item" typographyVariant="bodyPrimary">
            {courseName}
          </Link>
        ) : (
          <Typography2 component="p" variant="bodyPrimary">
            {courseName}
          </Typography2>
        )}
      </Grid>
      <Grid item>
        {isCourseEnrollable ? (
          <>
            (
            <Button css={styles.enrollBtn} edgeAlign="end" variant="ghost" onClick={handleEnrollClick}>
              {_t('Enroll')}
            </Button>
            )
          </>
        ) : (
          <Typography2 component="p" css={styles.status} variant="bodyPrimary">
            {statusText}
          </Typography2>
        )}
      </Grid>
    </Grid>
  );
};

export default SummaryCourseItem;
